export default __webpack_public_path__ + "static/media/VERY_Questionnaires.71d3e7ea.pdf";